<template>
  <div class="p-4 flex flex-wrap gap-4">
    <div v-if="userStore.user" class="w-full flex flex-row">
      <div class="grow">
        <h1>{{ t('home.title') }}</h1>
      </div>
    </div>
    <div class="w-full grid grid-cols-2 gap-4">
      <VaCard class="col-span-2 p-4">
        <div class="w-full flex flex-row items-center justify-evenly">
          <div class="flex flex-col">
            <h2>👋 {{ t('home.welcomeTitle') }}</h2>
          </div>
        </div>
      </VaCard>
      <UpcomingBirthdays class="col-span-1" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { VaCard } from 'vuestic-ui'
import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/stores/UserStore'
import UpcomingBirthdays from '@/components/dashboard/UpcomingBirthdays.vue'

const userStore = useUserStore()
const { t } = useI18n()
</script>
